export class DrugInteractionContentModel {
    public langId: number;
    public consumerDecscription: string;
    public professionalDecscription: string;
}
